import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=f9b82e98&scoped=true"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"
import style0 from "./EditProfileForm.vue?vue&type=style&index=0&id=f9b82e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b82e98",
  null
  
)

export default component.exports